class deliverySchedules extends HTMLElement {
    constructor() {
      super();
      if (!window?.deliveryScheduleInfo) return;
      const _this = this;
      this.currentDate = new Date();
      this.maxDate = new Date();
      this.maxDate.setDate(this.maxDate.getDate() + 30);
      this.ignoreYear = true;
      this.currentCartItem = null;
      this.bindEvents();
      this.setInitials();
      this.pikaDayFnc(this);
      this.showCartDeliveryScheduleModal();
  
      //show earliest delivery schedule message
      if (
        window.pageType === "product" &&
        this.querySelector(".earliest-delivery-schedule")
      ) {
        const earliestDeliverySchedule = this.findEarliestDeliverySchedule();
        this.querySelector(".earliest-delivery-schedule").innerHTML = `${
          this.querySelector(".earliest-delivery-schedule").dataset.icon
        } ${
          this.querySelector(".earliest-delivery-schedule").dataset
            .earliestDeliverySchedule
        } ${earliestDeliverySchedule}`;
      }
  
      //check when product cards loaded
      document.addEventListener("filter:sections_loaded", () => {
        console.log("product cards loaded");
        _this.checking_product_card();
      });
  
      //show cart alert when cart gets modified
      document.addEventListener("cart:modified", () => {
        this.showCartDeliveryScheduleModal();
        this.showCartAlert();
      });
  
      //restrict checkout form submission when schedule don't match
      document.querySelector('button[name="checkout"]') &&
        document
          .querySelector('button[name="checkout"]')
          .addEventListener("click", (e) => {
            this.currentDate = new Date();
            this.showCartAlert(e);
          });
  
      //set cart refresh interval
      if (window.pageType === "cart") {
        let cartRefreshCounter = 0;
        const cartRefreshInterval = setInterval(() => {
          cartRefreshCounter++;
          if (cartRefreshCounter >= 300) {
            clearInterval(cartRefreshInterval);
            location.reload();
          }
        }, 1000);
      }
  
      //check tab change to get the cart state
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden && window.pageType === "cart") {
          this.currentDate = new Date();
          this.showCartAlert();
        }
      });
  
      window.onfocus = () => {
        if (window.pageType === "cart") {
          this.currentDate = new Date();
          this.showCartAlert();
        }
      };
    }
    showCartDeliveryScheduleModal() {
      if (document.querySelector("[data-edit-delivery-schedule]")) {
        document?.querySelectorAll("[data-edit-delivery-schedule]")?.length &&
          [...document.querySelectorAll("[data-edit-delivery-schedule]")].forEach(
            (el) => {
              el.addEventListener("click", (ev) => {
                console.log("test");
                const cartItemSchedule = ev.currentTarget?.closest(
                  "[data-line-item-delivery]"
                )?.dataset?.lineItemDelivery
                  ? JSON.parse(
                      ev.currentTarget.closest("[data-line-item-delivery]")
                        .dataset.lineItemDelivery
                    )
                  : null;
                const deliverySchedule = ev.currentTarget?.closest(
                  "[data-line-item-delivery]"
                )?.dataset.deliverySchedule
                  ? JSON.parse(
                      ev.currentTarget.closest("[data-line-item-delivery]")
                        .dataset.deliverySchedule
                    )
                  : null;
                const item = ev.currentTarget?.closest(
                  "[data-line-item-delivery]"
                )?.dataset.item
                  ? JSON.parse(
                      ev.currentTarget.closest("[data-line-item-delivery]")
                        .dataset.item
                    )
                  : null;
  
                if (!cartItemSchedule || !deliverySchedule || !item) return;
  
                const itemScheduleDate = new Date(cartItemSchedule.date);
                this.currentCartItem = {
                  deliverySchedule: deliverySchedule,
                  deliveryInfo: cartItemSchedule,
                  item: item,
                };
                this.picker.setDate(cartItemSchedule.date);
                this.setInitials(itemScheduleDate);
                document
                  .querySelector(".delivery-schedule-modal")
                  .classList.remove("hide");
                document.body.classList.add("modal-opened");
              });
            }
          );
        document
          .querySelector(".delivery-schedule-modal .overlay")
          .addEventListener("click", () => {
            document
              .querySelector(".delivery-schedule-modal")
              .classList.add("hide");
            this.currentCartItem = null;
            document.body.classList.remove("modal-opened");
          });
        document
          .querySelector(".delivery-schedule-modal .close-modal")
          .addEventListener("click", () => {
            document
              .querySelector(".delivery-schedule-modal")
              .classList.add("hide");
            this.currentCartItem = null;
            document.body.classList.remove("modal-opened");
          });
      }
    }
    dateToMilliseconds(date) {
      if (!date?.getMonth || typeof date.getMonth !== "function") {
        date = new Date(date);
      }
      if (!date?.getTime) return null;
  
      return date.getTime();
    }
    // hasProcessDaysBuffer(selectedDate, processDays){
    //     if(processDays === 0) return true;
    //     if(!selectedDate) return null;
    //     if(typeof selectedDate.getTime !== 'function') selectedDate = new Date(selectedDate);
    //     let dateWithOffset = this.currentDate;
    //     dateWithOffset.setDate(dateWithOffset.getDate() + processDays);
    //     const dateWithOffsetMs = this.dateToMilliseconds(dateWithOffset);
    //     const selectedDateMs = this.dateToMilliseconds(selectedDate);
    //     this.currentDate = new Date();
    //     return selectedDateMs >= dateWithOffsetMs;
    // }
    isWithinCutoffTime(timeslot, selectedDate) {
      if (!selectedDate) return null;
      //if(!this.hasProcessDaysBuffer(selectedDate, timeslot?.process_days || 0)) return false;
      const cutoffDatetimeString = timeslot?.cutoff_time
        ? this.ignoreYear
          ? `${selectedDate}T${timeslot.cutoff_time.split("T")[1]}`
          : timeslot.cutoff_time
        : selectedDate;
      const processDays = timeslot?.process_days || 0;
      let cutoffDate = new Date(cutoffDatetimeString);
      cutoffDate.setDate(cutoffDate.getDate() - processDays);
      // console.log(this.dateToMilliseconds(this.currentDate));
      // console.log(this.dateToMilliseconds(cutoffDatetimeString));
      return (
        this.dateToMilliseconds(this.currentDate) <
        this.dateToMilliseconds(cutoffDate)
      );
    }
  
    findEarliestDeliverySchedule(returntHtml = true) {
      const deliveryScheduleData = window.deliveryScheduleInfo;
      let checkDate = deliveryScheduleData?.earliestDeliveryDate
        ? new Date(deliveryScheduleData.earliestDeliveryDate)
        : this.currentDate;
      let deliverySchedule = {},
        count = 0;
      checkDate =
        this.ignoreYear &&
        new Date(checkDate.setFullYear(this.currentDate.getFullYear()));
      do {
        const dateValue = this.dateFormat(checkDate);
        const day = this.nameOfDay(checkDate);
        const currentSchedule = {
          day: day,
          date: dateValue,
          time_slot: "",
          timeslot_raw: null,
        };
        const result = this.findAvailability(
          deliveryScheduleData,
          currentSchedule
        );
        let timeslots =
          result?.isProductAvailable &&
          !!result?.availableTimeslots?.length &&
          result.availableTimeslots.filter(
            (slot) => this.isWithinCutoffTime(slot, dateValue) && slot
          );
        timeslots =
          !!timeslots?.length &&
          timeslots.sort((a, b) => {
            const aTimeParts = a.time_from.split("T")[1].split("Z")[0].split(":");
            const bTimeParts = b.time_from.split("T")[1].split("Z")[0].split(":");
            return (
              parseInt(aTimeParts[0]) * 60 +
              parseInt(aTimeParts[1]) -
              (parseInt(bTimeParts[0]) * 60 + parseInt(bTimeParts[1]))
            );
          });
        if (!!timeslots?.length) {
          deliverySchedule = {
            date: currentSchedule.date,
            day: currentSchedule.day,
            timeslot: timeslots[0],
          };
        } else {
          checkDate.setDate(checkDate.getDate() + 1);
        }
        count++;
      } while (!deliverySchedule?.timeslot && count < 180);
      this.currentDate = new Date();
      if (returntHtml) {
        const deliveryDate = new Date(deliverySchedule.date);
        const inDateMonth = deliveryDate.toLocaleDateString("en-SG", {
          day: "numeric",
          month: "short",
        });
        return `${inDateMonth} ${deliverySchedule.timeslot.timeslot_label.replace(
          " - ",
          "-"
        )}`;
      } else {
        return deliverySchedule;
      }
    }
  
    findAvailability(scheduleData, currentDeliverySchedule) {
      if (
        typeof scheduleData !== "object" ||
        typeof currentDeliverySchedule != "object" ||
        !currentDeliverySchedule?.date
      )
        return null;
  
      let isProductAvailable = false,
        availableTimeslots = [];
      const date = new Date(currentDeliverySchedule.date);
      const {
        timeslots,
        timeSlotOverride,
        dateExclusions,
        earliestDeliveryDate,
      } = scheduleData;
      const dateInMdFormat = this.dateFormat(date, "md");
      //console.log({ timeslots, timeSlotOverride, dateExclusions, earliestDeliveryDate });
  
      //compare against earliest delivery date
      const edDate = earliestDeliveryDate ? new Date(earliestDeliveryDate) : null;
      const earliestDeliveryDateValue =
        this.ignoreYear && edDate
          ? this.dateFormat(
              new Date(edDate.setFullYear(this.currentDate.getFullYear()))
            )
          : earliestDeliveryDate;
      isProductAvailable =
        earliestDeliveryDateValue &&
        this.dateToMilliseconds(earliestDeliveryDateValue) &&
        this.dateToMilliseconds(earliestDeliveryDateValue) >
          this.dateToMilliseconds(date)
          ? false
          : true;
  
      //compare against date exclusions
      if (!!dateExclusions?.length) {
        const dateExclusionsInMdFormat = dateExclusions.map(
          (de) => `${de.split("-")[1]}-${de.split("-")[2]}`
        );
        //console.log(dateExclusionsInMdFormat, dateInMdFormat);
        if (dateExclusionsInMdFormat.includes(dateInMdFormat))
          isProductAvailable = false;
      }
  
      //compare against timeslot override
      const findOverrideEntryMatch =
        !!timeSlotOverride?.length &&
        timeSlotOverride.find(
          (entry) =>
            this.dateFormat(entry.time_to, "md") === dateInMdFormat ||
            this.dateFormat(entry.time_from, "md") === dateInMdFormat
        );
      if (isProductAvailable) {
        if (findOverrideEntryMatch) {
          availableTimeslots = timeslots;
          const overrideDay = this.nameOfDay(
            findOverrideEntryMatch.time_from
          ).toLowerCase();
  
          availableTimeslots =
            !!availableTimeslots?.length &&
            availableTimeslots.map((slot) => {
              return {
                cutoff_time:
                  overrideDay === slot.day.toLowerCase()
                    ? findOverrideEntryMatch.cutoff_time
                    : slot.cutoff_time,
                day: slot.day,
                process_days: slot.process_days,
                time_from:
                  overrideDay === slot.day.toLowerCase()
                    ? findOverrideEntryMatch.time_from
                    : slot.time_from,
                time_to:
                  overrideDay === slot.day.toLowerCase()
                    ? findOverrideEntryMatch.time_to
                    : slot.time_to,
                timeslot_label:
                  overrideDay === slot.day.toLowerCase()
                    ? findOverrideEntryMatch.timeslot_label
                    : slot.timeslot_label,
              };
            });
          availableTimeslots = availableTimeslots.filter(
            (slot) =>
              slot &&
              currentDeliverySchedule.day.toLowerCase() === slot.day.toLowerCase()
          );
          availableTimeslots = availableTimeslots.filter(
            (v, i, a) => a.findIndex((v2) => v2.day === v.day) === i
          );
          // return {
          //     isProductAvailable: isProductAvailable,
          //     availableTimeslots: availableTimeslots
          // }
        } else {
          //console.log(currentDeliverySchedule);
          availableTimeslots =
            !!timeslots?.length &&
            currentDeliverySchedule?.day &&
            timeslots.filter(
              (slot) =>
                currentDeliverySchedule.day.toLowerCase() ===
                slot.day.toLowerCase()
            );
        }
      }
  
      availableTimeslots =
        !!availableTimeslots?.length &&
        availableTimeslots.filter((slot) => {
          const slotDatetimeString = this.ignoreYear
            ? `${currentDeliverySchedule.date}T${slot.time_to.split("T")[1]}`
            : slot.time_to;
          return (
            slotDatetimeString &&
            this.dateToMilliseconds(slotDatetimeString) &&
            this.dateToMilliseconds(slotDatetimeString) >
              this.dateToMilliseconds(this.currentDate)
          );
        });
  
      isProductAvailable = !!availableTimeslots?.length;
  
      //if timeslot exists in current delivery schedule
      if (currentDeliverySchedule?.timeslot_raw) {
        const matchingTimeslots =
          !!availableTimeslots?.length &&
          availableTimeslots.filter(
            (slot) =>
              slot.time_from === currentDeliverySchedule.timeslot_raw.time_from &&
              slot.time_to === currentDeliverySchedule.timeslot_raw.time_to
          );
        isProductAvailable = !!matchingTimeslots?.length;
      }
  
      return {
        isProductAvailable: isProductAvailable,
        availableTimeslots: availableTimeslots,
      };
    }
  
    setInitials(date, timeString, timeslot, isTimeListClick) {
      const initialData = this.getCurrentDeliverySchedule();
      const _this = this;
      if (date && typeof date.getTime === "function") {
        initialData.date = this.dateFormat(date);
        initialData.day = this.nameOfDay(initialData.date);
        if (timeString && typeof timeslot === "object") {
          initialData.time_slot = timeString;
          initialData.timeslot_raw = timeslot;
        } else {
          if (
            !initialData?.timeslot_raw ||
            initialData.day !== initialData.timeslot_raw.day
          ) {
            initialData.time_slot = "";
            initialData.timeslot_raw = null;
          }
        }
      }
  
      //console.log({date, timeString, timeslot});
      !this.currentCartItem &&
        localStorage.setItem("delivery_schedule", JSON.stringify(initialData));
      window.delivery_schedule = initialData;
      const currentDate = initialData.date;
      const currentDateParts = currentDate.split("-");
      //const dayName = initialData.day;
      this.querySelector(
        "#datepicker"
      ).value = `${currentDateParts[2]}/${currentDateParts[1]}/${currentDateParts[0]}`;
      this.querySelector("#datepicker").setAttribute(
        "value",
        `${currentDateParts[2]}/${currentDateParts[1]}/${currentDateParts[0]}`
      );
      this.querySelector(".selected_time .h4").innerHTML =
        initialData.time_slot !== ""
          ? initialData.time_slot
          : "xx:xx AM - xx:xx PM";
  
      if (document.querySelector("#delivery_date_property")) {
        if (timeString)
          document.querySelector(
            "#delivery_date_property"
          ).value = `${currentDate}, ${timeString.trim()}`;
        else if (initialData?.time_slot)
          document.querySelector(
            "#delivery_date_property"
          ).value = `${currentDate}, ${initialData.time_slot.trim()}`;
        else document.querySelector("#delivery_date_property").value = "";
      }
  
      if (this.currentCartItem) {
        this.time_listShowHide(initialData);
      } else {
        this.time_listShowHide();
      }
  
      //this.time_slot_override(currentDate,dayName);
      //this.cutoffTime(currentDate,dayName);
      this.checking_product_card();
      if (
        this.querySelector(".selected_time .h4").getAttribute("template") !=
        "collection"
      ) {
        this.checking_addToCartButton();
      }
  
      // if(document.querySelector('#delivery_timeslot_property') && timeString){
      //     document.querySelector('#delivery_timeslot_property').value = timeString.trim();
      // }
      this.showCartAlert();
      //cart items availability popup
      // if(isTimeListClick && window.pageType !== 'cart'){
      //     this.checkAllProductsAvailability();
      // }
  
      if (this.currentCartItem && isTimeListClick) {
        setTimeout(() => {
          const body = JSON.stringify({
            id: this.currentCartItem.item.id,
            properties: {
              ...this.currentCartItem.item.properties,
              Delivery: `${currentDate}, ${initialData.time_slot.trim()}`,
            },
          });
          const line = this.currentCartItem.item.line;
  
          fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              document
                .querySelector(".delivery-schedule-modal")
                .classList.add("hide");
              _this.currentCartItem = null;
              document.body.classList.remove("modal-opened");
              location.reload();
  
              const cartItems =
                _this.closest("cart-items") || _this.closest("cart-drawer-items");
  
              const items = cartItems.querySelectorAll(".cart-item");
  
              if (parsedState.errors) {
                cartItems.updateLiveRegions(line, parsedState.errors);
                return;
              }
  
              cartItems.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );
              const cartDrawerWrapper = document.querySelector("cart-drawer");
              const cartFooter = document.getElementById("main-cart-footer");
  
              if (cartFooter)
                cartFooter.classList.toggle(
                  "is-empty",
                  parsedState.item_count === 0
                );
              if (cartDrawerWrapper)
                cartDrawerWrapper.classList.toggle(
                  "is-empty",
                  parsedState.item_count === 0
                );
  
              cartItems.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document
                    .getElementById(section.id)
                    .querySelector(section.selector) ||
                  document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              });
  
              this.updateLiveRegions(line, message);
  
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "cart-items",
                cartData: parsedState,
                variantId: variantId,
              });
              //dispatch custom event
              const customEvent = new CustomEvent("cart:modified");
              document.dispatchEvent(customEvent);
            })
            .catch(() => {
              const errors =
                document.getElementById("cart-errors") ||
                document.getElementById("CartDrawer-CartErrors");
              errors.textContent = window.cartStrings.error;
            })
            .finally(() => {});
        }, 100);
      }
    }
  
    getCurrentDeliverySchedule() {
      const today = this.dateFormat(this.currentDate);
      const earliestDeliverySchedule = this.findEarliestDeliverySchedule(false);
      const storedSchedule = JSON.parse(
        localStorage.getItem("delivery_schedule")
      );
  
      return storedSchedule &&
        earliestDeliverySchedule?.date &&
        this.dateToMilliseconds(earliestDeliverySchedule.date) <=
          this.dateToMilliseconds(storedSchedule.date)
        ? JSON.parse(localStorage.getItem("delivery_schedule"))
        : {
            date: earliestDeliverySchedule?.date || today,
            day: earliestDeliverySchedule?.day || this.nameOfDay(today),
            time_slot: earliestDeliverySchedule?.timeslot?.timeslot_label || "",
            timeslot_raw: earliestDeliverySchedule?.timeslot || null,
          };
    }
  
    bindEvents() {
      this.querySelectorAll(".time-wrap").forEach((item) => {
        item.addEventListener("click", this.onSummaryClick.bind(this));
      });
      this.querySelectorAll(".time-list li").forEach((time_list) => {
        time_list.addEventListener("click", this.onTimeListClick.bind(this));
      });
    }
  
    onSummaryClick(event) {
      this.querySelectorAll(".time-list").forEach((time_list) => {
        time_list.classList.toggle("active");
      });
      // event.currentTarget.nextElementSibling.classList.toggle("active");
    }
  
    onTimeListClick(event, schedule) {
      const currentDeliverySchedule =
        schedule || this.getCurrentDeliverySchedule();
      const dateString = event.currentTarget.innerHTML;
      const timeslotData = event.currentTarget.dataset?.item
        ? JSON.parse(event.currentTarget.dataset.item)
        : null;
      //this.querySelector('.selected_time .h4').innerHTML = dateString;
      this.querySelectorAll(".time-list").forEach((time_list) => {
        time_list.classList.remove("active");
      });
  
      this.setInitials(
        new Date(currentDeliverySchedule.date),
        dateString,
        timeslotData,
        true
      );
    }
  
    pikaDayFnc() {
      var $this = this;
      const currentDeliverySchedule = this.getCurrentDeliverySchedule();
      var earliestdelivery = $('#earliest-delivery').text();
      if(earliestdelivery){
        var minDate = new Date(earliestdelivery);
        var defaultDate = new Date(earliestdelivery) || this.currentDate;
        var maxdatevalue =  false;
      } else {       
        var minDate = $this.currentDate;
        var maxdatevalue = $this.maxDate;
        var defaultDate = new Date(currentDeliverySchedule.date) || this.currentDate; 
      }      

      this.picker = new Pikaday({
        field: document.getElementById("datepicker"),
        format: "DD-MM-YYYY",
        minDate: minDate,
        maxDate: maxdatevalue,
        defaultDate: defaultDate,
        // minDate: $this.currentDate,
        // maxDate: $this.maxDate,
        // defaultDate:  new Date(currentDeliverySchedule.date) || this.currentDate,
        setDefaultDate: true,
        disableWeekends: false,
        toString(date, format) {
          // you should do formatting based on the passed format,
          var get_Month = date.getMonth() + 1;
          var get_Date = date.getDate();
          const day = get_Date > 9 ? get_Date : "0" + get_Date;
          const month = get_Month > 9 ? get_Month : "0" + get_Month;
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        },
        disableDayFn: function (date) {
          // console.log('date exclusion = '+$this.isDatedisable(date));
          return $this.isDatedisable(date); // if show without array date
        },
        onSelect() {
          //// console.log($this);
          const date = this._d; //date data
  
          $this.setInitials(date);
          //if(window.pageType !== 'cart') $this.checkAllProductsAvailability();
        },
      });
    }
  
    dateFormat(date, mode) {
      if (typeof date.getMonth !== "function") date = new Date(date);
      if (typeof date.getTime !== "function") return "";
      const get_Date = date.getDate();
      const get_Month = date.getMonth() + 1;
      const day = get_Date > 9 ? get_Date : "0" + get_Date;
      const month = get_Month > 9 ? get_Month : "0" + get_Month;
      // const year = this.ignoreYear
      //   ? this.currentDate.getFullYear()
      //   : date.getFullYear();
      const year = date.getFullYear();
      const hours = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
      const minutes =
        date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
      const seconds =
        date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
  
      if (mode === "md") {
        return month + "-" + day;
      }
  
      if (mode === "hms") {
        return hours + ":" + minutes + ":" + seconds;
      }
  
      return year + "-" + month + "-" + day;
    }
  
    isDatedisable(date) {
      const formattedDate = this.dateFormat(date);
      const earliestDeliverySchedule = this.findEarliestDeliverySchedule(false);
      const schedule = {
        date: formattedDate,
        day: this.nameOfDay(date),
        time_slot: "",
        timeslot_raw: null,
      };
      const result = this.findAvailability(window.deliveryScheduleInfo, schedule);
  
      return (
        Datedisable.includes(formattedDate) ||
        this.dateToMilliseconds(earliestDeliverySchedule.date) >
          this.dateToMilliseconds(formattedDate) ||
        !result?.availableTimeslots?.length
      );
    }
  
    nameOfDay(dateValue) {
      if (!dateValue) return null;
      var date =
        dateValue?.getTime && typeof dateValue.getTime === "function"
          ? dateValue
          : new Date(dateValue); // Example date: March 20, 2024
      var dayIndex = date.getDay();
      var days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      var dayName = days[dayIndex];
      return dayName;
    }
  
    setLocalTime(
      date = this.currentDate,
      time = { h: 0, m: 0, s: 0, ms: 0 },
      tz = "Asia/Singapore"
    ) {
      let { h, m, s, ms } = time;
      let z = (n, len) => ("00" + n).slice(-len);
  
      let [datePart, offset] = date
        .toLocaleDateString("sv", {
          timeZone: tz,
          timeZoneName: "longOffset",
        })
        .split(" GMT");
  
      let timestamp =
        `${datePart}T` +
        `${z(h || 0, 2)}:${z(m || 0, 2)}:${z(s || 0, 2)}.${z(ms || 0, 3)}` +
        `${offset.replace(String.fromCharCode(8722), "-")}`;
  
      return new Date(timestamp);
    }
  
    time_listShowHide(schedule) {
      const currentDeliverySchedule =
        schedule || this.getCurrentDeliverySchedule();
      const deliveryScheduleInfo =
        this.currentCartItem?.deliverySchedule || window.deliveryScheduleInfo;
        
      //console.log({deliveryScheduleInfo});
      const result = this.findAvailability(
        deliveryScheduleInfo,
        currentDeliverySchedule
      );

      //Modified by Gyrovi. Select first available timeslot if the local storage value is not availabe for the current product.
      const defaultTimeslotHtml = currentDeliverySchedule?.time_slot && currentDeliverySchedule.time_slot !== '' ? currentDeliverySchedule.time_slot : 'xx:xx AM - xx:xx PM';
      //this.querySelector('.selected_time .h4').innerHTML = defaultTimeslotHtml;
      //console.log(result);
      var timeslot_available = false;
      var first_available_timeslot = '';
      result?.availableTimeslots.forEach((timeSlot) => {
        if(defaultTimeslotHtml == timeSlot.timeslot_label){
          timeslot_available = true;
        }
        if(first_available_timeslot == '' && this.isWithinCutoffTime(timeSlot, currentDeliverySchedule.date)){
          first_available_timeslot = timeSlot.timeslot_label;
        }
      });      
      if(timeslot_available == false){
        if(document.querySelector("#delivery_date_property")){
          var delivery_date_property_val = document.querySelector("#delivery_date_property").value;
          delivery_date_property_val = delivery_date_property_val.split(', ');
          if(delivery_date_property_val.length > 0){
            delivery_date_property_val[1] = first_available_timeslot;
            document.querySelector("#delivery_date_property").value = delivery_date_property_val.join(', ');
          }
        }
        this.querySelector('.selected_time .h4').innerHTML = first_available_timeslot;
      }
      
      this.querySelector(".time-list").innerHTML = "";
      !!result?.availableTimeslots?.length
        ? result?.availableTimeslots.forEach((timeSlot) => {
            const slotEl = document.createElement("li");
            slotEl.dataset.item = JSON.stringify(timeSlot);
            slotEl.dataset.time_from = timeSlot.time_from;
            slotEl.dataset.time_to = timeSlot.time_to;
            slotEl.dataset.day = timeSlot.day;
            slotEl.innerHTML = timeSlot.timeslot_label;
            slotEl.addEventListener("click", (e) => {
              this.onTimeListClick(e, schedule);
            });
            // console.log(!this.isWithinCutoffTime(timeSlot, currentDeliverySchedule.date));
            !this.isWithinCutoffTime(timeSlot, currentDeliverySchedule.date)
              ? slotEl.classList.add("disabled")
              : slotEl.classList.remove("disabled");
            this.querySelector(".time-list").appendChild(slotEl);
          })
        : (this.querySelector(
            ".time-list"
          ).innerHTML = `<li class="no-slots-available">${
            window.deliveryScheduleInfo.noSlotsAvailableText ||
            "No slots available"
          }</li>`);
  
      if (
        this.querySelector(".time-list li:not(.disabled)") &&
        !currentDeliverySchedule?.timeslot_raw &&
        window.pageType === "product"
      ) {
        this.querySelector(".time-list li:not(.disabled)").click();
      }
    }
  
    checking_product_card() {
      var productItems = document.querySelectorAll("[data-product-card]");
      !!productItems?.length &&
        productItems.forEach((el) => {
          const deliveryScheduleData = el.dataset.deliverySchedule
            ? JSON.parse(el.dataset.deliverySchedule)
            : null;
          const currentSchedule = this.getCurrentDeliverySchedule();
          const result = this.findAvailability(
            deliveryScheduleData,
            currentSchedule
          );
          if (!currentSchedule?.timeslot_raw) {
            el.querySelector(".product-availability").classList.remove(
              "available"
            );
            el.querySelector(".product-availability").innerHTML = "";
          } else {
            if (result?.isProductAvailable) {
              el.querySelector(".product-availability").classList.add(
                "available"
              );
              el.querySelector(".product-availability").innerHTML =
                el.querySelector(
                  ".product-availability"
                ).dataset.contentAvailable;
            } else {
              el.querySelector(".product-availability").classList.remove(
                "available"
              );
              el.querySelector(".product-availability").innerHTML =
                el.querySelector(
                  ".product-availability"
                ).dataset.contentUnavailable;
            }
          }
        });
    }
  
    checking_addToCartButton() {
      const currentDeliverySchedule = this.getCurrentDeliverySchedule();
      const result = this.findAvailability(
        window.deliveryScheduleInfo,
        currentDeliverySchedule
      );
      const container = this.closest(".product__info-container");
      const _this = this;
      if (!container) return;
  
      setTimeout(() => {
        if (
          result.isProductAvailable &&
          currentDeliverySchedule.timeslot_raw &&
          _this.isWithinCutoffTime(
            currentDeliverySchedule.timeslot_raw,
            currentDeliverySchedule.date
          )
        ) {          
          container
            .querySelector(".product-form__buttons .product-form__submit")
            .classList.remove("disabled-addtocart");
        } else {
          container
            .querySelector(".product-form__buttons .product-form__submit")
            .classList.add("disabled-addtocart");
        }
      }, 100);
    }
  
    showCartAlert(checkoutButtonEvent) {
      if (!document.querySelector(".cart__contents")) return;
      //const cartForm = document.querySelector('form[action="/cart"]');
      let showGlobalAlert = false,
        disableCheckout = false,
        firstItemSchedule = null;
      const ipcDisabled =
        document?.querySelector('[name="checkout"]')?.dataset?.ipc &&
        document.querySelector('[name="checkout"]').dataset.ipc === "disabled";
      //const currentDeliverySchedule = this.getCurrentDeliverySchedule();
      if (
        !!document?.querySelectorAll(".cart__contents [data-line-item-delivery]")
          ?.length
      ) {
        const firstItem = [
          ...document?.querySelectorAll(
            ".cart__contents [data-line-item-delivery]"
          ),
        ][0];
        const scheduleData = JSON.parse(firstItem.dataset.deliverySchedule);
        firstItemSchedule = JSON.parse(firstItem.dataset.lineItemDelivery);
        const result = this.findAvailability(scheduleData, firstItemSchedule);
        firstItemSchedule.timeslot_raw =
          !!result?.availableTimeslots?.length &&
          result.availableTimeslots.filter(
            (slot) =>
              this.isWithinCutoffTime(slot, firstItemSchedule.date) &&
              firstItemSchedule.time_slot === slot.timeslot_label &&
              slot
          );
        [
          ...document?.querySelectorAll(
            ".cart__contents [data-line-item-delivery]"
          ),
        ].forEach((el) => {
          const elSchedule = JSON.parse(el.dataset.lineItemDelivery);
          if (
            // Modified by Gyrovi to match date only.
            // !(
            //   firstItemSchedule.date === elSchedule.date &&
            //   firstItemSchedule.time_slot === elSchedule.time_slot
            // )
            !(
              firstItemSchedule.date === elSchedule.date
            )
          ) {
            showGlobalAlert = true;
            disableCheckout = true;
            return false;
          }
        });
      }
      // !!document?.querySelectorAll('.cart__contents .cart-item')?.length && [...document?.querySelectorAll('.cart__contents .cart-item')].forEach(el => {
      //     const deliveryScheduleData = el.dataset.deliverySchedule ? JSON.parse(el.dataset.deliverySchedule) : null;
      //     const result = this.findAvailability(deliveryScheduleData, currentDeliverySchedule);
      //     const timeslots = result?.isProductAvailable && !!result?.availableTimeslots?.length && result.availableTimeslots.filter(slot => this.isWithinCutoffTime(slot, currentDeliverySchedule.date) && slot);
      //     if(!timeslots?.length) {
      //         showGlobalAlert = true;
      //         disableCheckout = true;
      //         el.querySelector('.alert_message_desktop').innerHTML = el.querySelector('.alert_message_desktop').dataset.html;
      //         el.querySelector('.alert_message_mobile').innerHTML = el.querySelector('.alert_message_mobile').dataset.html;
      //     } else {
      //         el.querySelector('.alert_message_desktop').innerHTML = '';
      //         el.querySelector('.alert_message_mobile').innerHTML = '';
      //     }
      // });
      console.log({firstItemSchedule});
      if (firstItemSchedule?.date && firstItemSchedule?.time_slot) {
        const firstItemScheduleDate = new Date(firstItemSchedule.date);
        
        // let firstItemScheduleTime = firstItemSchedule.time_slot
        //   .split("-")[0]
        //   .trim();
        // const timeParts = firstItemScheduleTime
        //   .toUpperCase()
        //   .replace("AM", "")
        //   .replace("PM", "")
        //   .trim()
        //   .split(":");
        // const timeObject = {
        //   hour: parseInt(timeParts[0]),
        //   min: parseInt(timeParts[1]),
        // };
        // if (firstItemScheduleTime.toUpperCase().includes("AM")) {
        //   if (timeObject.hour === 12) timeObject.hour = 0;
        // } else if (firstItemScheduleTime.toUpperCase().includes("PM")) {
        //   if (timeObject.hour < 12) timeObject.hour += 12;
        // }

        // Convert to Singapore Time (Nov 21)
        function convertUTCToSGT(utcDateString) {
          const utcDate = new Date(utcDateString);
          const singaporeTime = new Date(
            utcDate.toLocaleString("en-US", { timeZone: "Asia/Singapore" })
          );
          const time = {
            hour: singaporeTime.getHours(),
            mins: singaporeTime.getMinutes(),
          };
          return time;
        }
        /*** Commented by Gyrovi and added below block to check cutoff time for each item.
        const cutoffTimeUTC =
          firstItemSchedule.timeslot_raw[0] &&
          firstItemSchedule.timeslot_raw[0].cutoff_time;
        const timeObject = convertUTCToSGT(cutoffTimeUTC);
        // Convert to Singapore Time (Nov 21) ends here
        
        const firstItemScheduleDateTime = this.setLocalTime(
          firstItemScheduleDate,
          { h: timeObject.hour, m: timeObject.min, s: 0, ms: 0 }
        );
        //console.log(firstItemSchedule?.timeslot_raw?.length);
        if (
          this.dateToMilliseconds(firstItemScheduleDateTime) <=
            this.dateToMilliseconds(this.currentDate) ||
          !firstItemSchedule?.timeslot_raw?.length
        ) {
          disableCheckout = true;
          showGlobalAlert = true;
        }*/

        [
          ...document?.querySelectorAll( 
            ".cart__contents [data-line-item-delivery]"
          ),
        ].forEach((el) => {
          const scheduleData = JSON.parse(el.dataset.deliverySchedule);
          const elSchedule = JSON.parse(el.dataset.lineItemDelivery);
          const result = this.findAvailability(scheduleData, elSchedule);
          elSchedule.timeslot_raw =
            !!result?.availableTimeslots?.length &&
            result.availableTimeslots.filter(
              (slot) =>
                this.isWithinCutoffTime(slot, elSchedule.date) &&
                elSchedule.time_slot === slot.timeslot_label &&
                slot
            );

          console.log({elSchedule});
          const cutoffTimeUTC =
            elSchedule.timeslot_raw[0] &&
            elSchedule.timeslot_raw[0].cutoff_time;
          const timeObject = convertUTCToSGT(cutoffTimeUTC);
          const elScheduleDate = new Date(elSchedule.date);
          
          const elScheduleDateTime = this.setLocalTime(
            elScheduleDate,
            { h: timeObject.hour, m: timeObject.min, s: 0, ms: 0 }
          );
          
          if (
            this.dateToMilliseconds(elScheduleDateTime) <=
              this.dateToMilliseconds(this.currentDate) ||
            !elSchedule?.timeslot_raw?.length
          ) {
            disableCheckout = true;
            showGlobalAlert = true;
            return false;
          }
        });

      } else {
        disableCheckout = true;
        showGlobalAlert = true;
      }

      if (document.querySelector(".alert-message-global")) {
        document.querySelector(".alert-message-global").innerHTML =
          showGlobalAlert
            ? document.querySelector(".alert-message-global").dataset.html
            : "";
      }
      if (document.querySelector(".ipc-disabled-error-message")) {
        document.querySelector(".ipc-disabled-error-message").innerHTML =
          ipcDisabled
            ? document.querySelector(".ipc-disabled-error-message").dataset.html
            : "";
      }

      if (ipcDisabled) {
        disableCheckout = true;
      }

      if (showGlobalAlert || disableCheckout) {
        if (
          document.querySelector('[data-name="attributes[date]"]') &&
          document.querySelector('[data-name="attributes[timeslot]"]') &&
          firstItemSchedule
        ) {
          document
            .querySelector('[data-name="attributes[date]"]')
            .removeAttribute("name");
          document
            .querySelector('[data-name="attributes[timeslot]"]')
            .removeAttribute("name");
          document.querySelector('[data-name="attributes[date]"]').value = "";
          document.querySelector('[data-name="attributes[timeslot]"]').value = "";
        }
        document
          ?.getElementById("checkout")
          ?.setAttribute("disabled", "disabled");
        document?.getElementById("checkout")?.removeAttribute("type");
        document?.getElementById("checkout")?.classList.add("disabled");
        document
          ?.querySelector(".dynamic-checkout__content")
          ?.classList.add("hide");
      } else {
        if (
          document.querySelector('[data-name="attributes[date]"]') &&
          document.querySelector('[data-name="attributes[timeslot]"]') &&
          firstItemSchedule
        ) {
          document
            .querySelector('[data-name="attributes[date]"]')
            .setAttribute(
              "name",
              document
                .querySelector('[data-name="attributes[date]"]')
                .getAttribute("data-name")
            );
          document
            .querySelector('[data-name="attributes[timeslot]"]')
            .setAttribute(
              "name",
              document
                .querySelector('[data-name="attributes[timeslot]"]')
                .getAttribute("data-name")
            );
          document.querySelector('[data-name="attributes[date]"]').value =
            firstItemSchedule.date;
          document.querySelector('[data-name="attributes[timeslot]"]').value =
            firstItemSchedule.time_slot;
        }
        document?.querySelector('[name="checkout"]')?.removeAttribute("disabled");
        document
          ?.querySelector('[name="checkout"]')
          ?.setAttribute("type", "submit");
        document
          ?.querySelector('[name="checkout"]')
          ?.classList.remove("disabled");
        document
          ?.querySelector(".dynamic-checkout__content")
          ?.classList.remove("hide");
      }
  
      if (
        checkoutButtonEvent?.currentTarget.classList.contains(
          "cart__checkout-button"
        ) &&
        (showGlobalAlert || disableCheckout)
      ) {
        checkoutButtonEvent.preventDefault();
        location.reload();
      }
  
      if (
        !showGlobalAlert &&
        !disableCheckout &&
        firstItemSchedule?.date &&
        firstItemSchedule?.time_slot &&
        window?.cartInfo?.attributes?.date &&
        window?.cartInfo?.attributes?.timeslot &&
        window.cartInfo.attributes.date !== firstItemSchedule.date &&
        window.cartInfo.attributes.timeslot !== firstItemSchedule.time_slot
      ) {
        window.cartInfo.attributes.date = firstItemSchedule.date;
        window.cartInfo.attributes.timeslot = firstItemSchedule.time_slot;
        fetch(`${routes.cart_update_url}.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: {
              ...window.cartInfo.attributes,
              date: firstItemSchedule.date,
              timeslot: firstItemSchedule.time_slot,
            },
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            window.cartInfo.attributes.date = data.attributes.date;
            window.cartInfo.attributes.timeslot = data.attributes.timeslot;
          });
      }
    }
  
    checkAllProductsAvailability() {
      const _this = this;
      const currentDeliverySchedule = this.getCurrentDeliverySchedule();
      if (!currentDeliverySchedule?.timeslot_raw) {
        if (document.querySelector(".cart-items-availability-popup")) {
          document.querySelector(".cart-items-availability-popup").innerHTML = "";
          document
            .querySelector(".cart-items-availability-popup")
            .classList.add("hide");
        }
        return;
      }
      fetch(`${routes.cart_url}?section_id=cart-items-delivery-schedule-info`)
        .then((Response) => Response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const infoContent = html?.querySelector(".shopify-section")?.innerHTML;
          const deliverySchedules = infoContent && JSON.parse(infoContent);
          let allItemsAvailable = true;
  
          if (!deliverySchedules?.length) {
            console.info(
              "either cart is empty or delivery schedule info not found for cart items"
            );
            return;
          }
  
          deliverySchedules.forEach((schedule) => {
            const result = _this.findAvailability(
              schedule,
              currentDeliverySchedule
            );
            const timeslots =
              result?.isProductAvailable &&
              !!result?.availableTimeslots?.length &&
              result.availableTimeslots.filter(
                (slot) =>
                  this.isWithinCutoffTime(slot, currentDeliverySchedule.date) &&
                  slot
              );
            if (!timeslots?.length) {
              allItemsAvailable = false;
              return false;
            }
          });
          //console.log(allItemsAvailable);
  
          if (document.querySelector(".cart-items-availability-popup")) {
            if (allItemsAvailable) {
              document
                .querySelector(".cart-items-availability-popup")
                .classList.remove("unavailable");
              document.querySelector(".cart-items-availability-popup").innerHTML =
                document.querySelector(
                  ".cart-items-availability-popup"
                ).dataset.available;
            } else {
              document
                .querySelector(".cart-items-availability-popup")
                .classList.add("unavailable");
              document.querySelector(".cart-items-availability-popup").innerHTML =
                document.querySelector(
                  ".cart-items-availability-popup"
                ).dataset.unavailable;
            }
            document
              .querySelector(".cart-items-availability-popup")
              .classList.remove("hide");
          }
  
          document.querySelector(".cart-items-availability-popup .close-popup") &&
            document
              .querySelector(".cart-items-availability-popup .close-popup")
              .addEventListener("click", (ev) => {
                ev.currentTarget
                  .closest(".cart-items-availability-popup")
                  .classList.add("hide");
                ev.currentTarget.closest(
                  ".cart-items-availability-popup"
                ).innerHTML = "";
              });
        });
    }
  }
  
  customElements.define("delivery-schedules", deliverySchedules);
  